interface LogosArray {
    [productQualificationName: string]: string;
}
const QualificationLogos: LogosArray = {
    Spark: '/img/lumina-spark-logo_orange-pos.png',
    EmotionEnhanced: '/img/lumina-emotion-logo_purple-pos.png',
    EmotionalAgility: '/img/lumina-emotion-logo_purple-pos.png',
    Sales: '/img/lumina-sales-logo_red-pos.png',
    SelectV2: '/img/lumina-select-logo_blue-pos.png',
    Leader: '/img/lumina-leader-logo_light-blue-pos.png',
    SparkMarketing: '/img/lumina-spark-logo_orange-pos.png',
    LuminaLife: '/img/lumina-logo.png',
    Youth: '/img/lumina-logo.png',
    Talent: '/img/lumina-logo.png',
    NHSSelect: '/img/lumina-logo.png',
};
export default QualificationLogos;
